/** Real `leagues.id` values are UUIDs. Lobby and demo boards use synthetic ids. */
const PERSISTED_LEAGUE_ID_RE =
    /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export function isPersistedLeagueId(leagueId: string | null | undefined): boolean {
    return PERSISTED_LEAGUE_ID_RE.test(String(leagueId ?? "").trim());
}
